import React from 'react';
import { Link } from 'react-router-dom';

export default ({ course }) => {
  if (!course) {
    return null;
  }
  return (
    <div className="course--widget">
      <div className="container">
        <div className="course--widget__wrapper">
          <h1>{course.name}</h1>
          <p>{course.description}</p>
          <div className="course--widget--bot">
            {course.progress ? (
              <div className="course-progress">
                <div className="course-progress__bar">
                  <div
                    className="course-progress__bar course-progress__bar--progress"
                    style={{ width: `${course.progress * 3}px` }}
                  />
                </div>
                <span>{course.progress}%</span>
              </div>
            ) : null}
            {course.complete ? (
              <Link to={`/subscription/courses`}>
                <span className="button">View More Courses</span>
              </Link>
            ) : (
              <Link to={`/subscription/courses/${course.id}`}>
                <span className="button">{course.progress ? 'Continue' : 'Start Course'}</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/subscription/dashboard/SixtyDayTrainingCourseWidget.js